import { memo } from 'react';
import { cx } from '@emotion/css';
import { motion } from 'motion/react';
import { Icon, IconName } from '@frontend/icons';
import { NakedButton } from '../../../../naked';
import { Text } from '../../../text';
import { useRadioContext } from '../../providers';
import { RadioStyles } from '../radio/radio.styles';
import { RadioCardStyles } from './radio-card.styles';

type Props = {
  title: React.ReactNode;
  description?: React.ReactNode;
  selectionContent?: React.ReactNode;
  value: string;
  trackingId?: string;
  className?: string;
  iconName?: IconName;
};
const MotionNakedButton = motion.create(NakedButton);
export const RadioCardOption = memo(
  ({ title, description, selectionContent, trackingId, value, className, iconName }: Props) => {
    const { getOptionProps, animate } = useRadioContext();
    const { active, checked, onChange, ...optProps } = getOptionProps(value);
    const radioStyles = RadioStyles.radio({ active, checked, disabled: optProps.disabled });
    const radioOptionStyles = RadioCardStyles.radioCard;
    const radioOptionContentContainerStyles = RadioCardStyles.radioCardContentContainer;
    const radioOptionContentStyles = RadioCardStyles.radioCardContent;
    const radioCheckboxStyles = RadioCardStyles.radioCheckbox;
    const radioIconStyles = RadioCardStyles.radioIcon;
    const radioDescriptionStyles = RadioCardStyles.radioDescription;

    const WrapperButton = animate ? MotionNakedButton : NakedButton;
    const animProps = animate ? { layout: true, transition: { layout: { duration: 0.3, ease: 'easeOut' } } } : {};

    return (
      <WrapperButton
        {...animProps}
        css={radioOptionStyles}
        {...optProps}
        className={cx(optProps.className, className)}
        onClick={onChange}
        type='button'
        trackingId={trackingId}
      >
        <div css={[radioStyles, radioCheckboxStyles]} />
        <div css={radioOptionContentContainerStyles}>
          <div css={[radioOptionContentStyles]}>
            <Text as='span' size='medium' weight='bold'>
              {title}
            </Text>
            {description && (
              <Text as='span' size='small' color='subdued' css={radioDescriptionStyles}>
                {description}
              </Text>
            )}
            {/* NOTE: this will block radio option events from triggering while user interacting with input */}
            <div
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
              css={{ ':empty': { display: 'none' } }}
            >
              {checked && selectionContent}
            </div>
          </div>
          {iconName && <Icon name={iconName} className='button-icon' color='default' css={radioIconStyles} />}
        </div>
      </WrapperButton>
    );
  }
);
RadioCardOption.displayName = 'RadioCardOption';
